<template>
  <div class="people-tadahiro">
    <People
    :isReverse="true" 
    :image="require('../assets/people_tadahiro/hero.jpg')" 
    :name="require('../assets/people_tadahiro/name.svg')" 
    mainCatch="クライアントの<br>
            課題の根幹を明らかにすることで<br>
            システムは真の目的を<br>
            達成できる。" 
    background="技術コンサルティング事業部<br>
              第二コンサルティング部<br>
              シニアコンサルタント" 
    history="大手冠系SIerにて研究所勤務を経験後、「より上流の仕事を手掛けたい」と、2004年に豆蔵に入社。入社後は一貫して、エンタープライズ領域のコンサルティングに従事。大手金融系企業の基幹システムの刷新などを、プロジェクトリーダーとして手掛けてきた。大学時代は電子情報工学を専攻。コンピュータサイエンスを学びながら、プログラミング技術を習得。「天才的なプログラマを除けば、学内で上位3位くらいには入っていたと思います」" 
    >
      <PeopleArticle
        :isReverse="true" 
        text='<p class="catch">
              他のSIerよりも上流のポジションで、<br>
              クライアントの業務課題の解決にコミットする。
            </p>
            <p class="body">
              豆蔵のエンタープライズ領域のコンサルティング業務は、クライアントの業務上の課題を明らかにすることから始まります。<i>「システム開発ありき」でプロジェクトが始まるのではなく、その上流である課題を明確化するフェーズから取り組みます。</i>他のSIerよりも上流のポジションでコミットするので、SIerに対する開発マネジメントや技術的な支援も、重要な仕事になります。ただし、豆蔵は技術力にこだわりを持つ会社であり、アウトプットされたコードを重視するので、重要な箇所は自分たちで書くことも多々あります。つまり、ITコンサルの会社なのですが、経営の視点からも考えますし、現場の開発者の視点も持っています。双方の気持ちが分かるので、<i>青写真に終わらない、実際に問題を解決できるソリューションを提供できるのが、私たちの強みの1つです。</i>
            </p>
            <p class="catch">
              「モデリング技術」を武器に、複雑な課題を明確化する。
            </p>
            <p class="body">
              課題を明確化するフェーズでは、クライアントの「業務フローの可視化」を大切にしています。あくまでシステムの納品ではなく、業務の改善が目的ですので、まずはフローを描いてクライアントと問題点をディスカッションすることが多いです。<i>理想的な業務フローを設計して現状と比べることで、システム化の必要な箇所をあぶり出します。そのプロセスで私たちの武器になるのが、「モデリング技術」。</i>複雑な業務フローや業務で扱う情報を抽象化して、相関関係や因果関係を明確化する手法です。あるSIerの業務システム刷新のプロジェクトを受注したときには、社長と役員、現場リーダーに留まらず、協力会社の社長にまで集まってもらいました。私と若手コンサルタントで、その場でシステム仕様書を見ながら、モデリング技術を活用して、業務同士の関係性や因果関係を整理していきました。すると、概念が整理され、冗長な部分や不必要な関係性が見えてきて、課題の明確化に成功。さらに、経営と現場での認識を揃えるために用語集を作成。その結果、非常に明快なシステム設計が可能になりました。
            </p>' 
        :image="require('../assets/people_tadahiro/image01.jpg')" 
      />
      <PeopleArticle
        :isReverse="true" 
        text='<p class="catch">
              大規模システムの根幹を開発。<br>
              だから、ブレずに目的が達成できる。
            </p>
            <p class="body">
              私が手掛けてきた中で代表的な案件は、2010年から2年に渡って手掛けた、ある大手金融系企業の基幹システム刷新プロジェクトです。このプロジェクトは、豆蔵がアサインされる前に、クライアントは別の大手SIerに依頼していました。しかし、難易度が高く開発が進んでいなかった。<i>私たちは、モデリング技術を活用して業務の棚卸しを行い、細かくプロトタイプをつくって提案を積み重ねました。</i>その無駄の無い内容が評価され、フレームワークの根幹は豆蔵が担当することに。さらに、どのアプリケーションでも使う共通部分の開発も任せられるようになり、私はそのプロジェクトリーダーを務めていました。カレンダーのモジュールが必要であればつくりますし、マスターメンテナンスの仕組みが必要になったタイミングでは、全てのアプリケーションに応用できるものを開発。各チームと連携するポジションを担っていたので、クライアントに「全体のソースコードの品質を確認してもらえますか？」と依頼をいただき、他社のSIerが書いたソースコードのレビューも行っていましたね。
            </p>
            <p class="body">
              大規模プロジェクトを成功に導くために、私が心掛けていることがあります。それは、<i>「つながり」を意識すること。</i>単体としての機能を強化するだけでは、業務課題の解決には寄与できません。「そもそも何のためにその機能が必要なのか」を考え、「システムと現場社員とのつながりはどうなっているのか」をイメージすることが大切です。開発の工程においても、「関係者や周りの作業者に何を伝えたらよいのか」を常に配慮しながら進めています。全体の中で、自分の仕事の位置づけを明確にして、その仕事の意味や他への影響を理解する。そうすることで、全体最適を実現できますし、クライアントへの提案も通りやすくなります。より良いものをつくってやろう、というモチベーションも向上しますね。
            </p>
            <p class="catch">
              クライアントの現場担当者にいただいた、評価の声。
            </p>
            <p class="body">
              改修前は、黒い画面に白いフォントで表示するホスト系のシステムだったのですが、ブラウザを用いるWeb系のシステムに刷新。また、そのクライアント企業は幅広い業務を展開しているのですが、この全ての業務を一元的に管理できるようにしました。システムがバラバラだった時代では、冗長待ちが多く発生していて、顧客情報を1日に1回しか突き合わせできなかったと聞いています。システム刷新後は、リアルタイム処理が可能になりました。クライアントの現場担当者からの評価も高く、<i>「業務自体が効率化されたのはもちろんですが、UIも使いやすくなって、皆が喜んでくれています」</i>という言葉をいただきました。システム開発は納品がゴールではなく、クライアントの業務効率化がゴールですから、嬉しかったですね。
            </p>
            <p class="body">
              2012年のカットオーバー以降も、私自身の関与は続いています。最近の改善事項としては、ブラウザを自動的に操作する「Selenium」というライブラリを活用して、Javaのテストコードを操作すれば、システムの変更箇所を自動的に収集できる仕組みを開発。画面やデータベースの更新内容の変化を検出します。<i>作業の影響範囲を可視化するこのツールを導入することで、開発がよりスムーズに進むようになりました。</i>今後は、機械学習の実装や、あらゆる自動化を推進していきたいですね。
            </p>
            <p class="body">
              システム自体の目的は「業務の効率化」で変わりませんが、その目的を達成する手段は、時代によって変わっていくもの。<i>柔軟に新しい技術を取り入れるチャレンジは、抜かりなく実行していきたいと考えています。</i>
            </p>' 
        :image="require('../assets/people_tadahiro/image02.jpg')" 
      />
      <PeopleArticle
        :isReverse="true" 
        text='<p class="catch">
              エキスパートからの学びでいくらでも高みに登れる。
            </p>
            <p class="body">
              私が大手SIerから転職した当時、<i>最も驚いたのは、豆蔵社員の技術的な知識の幅と深さ。</i>皆が高度な技術書を読み漁っていて、尋常ではない勉強量をこなしていました。何か分からないことがあれば、すぐに相談できますし、真剣にディスカッションをすることで、お互いを高め合っていける環境ができ上がっている。クライアントへの提案を行う際も、「もっとこうした方が良い」という意見が山のように出てきます。あくまで知識や技術だけを追求するのではなく、その先も見据えているからこそ、有意義な議論ができるのだと思います。
            </p>
            <p class="catch">
              「攻めの姿勢」で、<br>
              貪欲に吸収する意欲があれば、経験は必要無い。
            </p>
            <p class="body">
              <i>私たちの部署で求める人物像は「勉強熱心な人」です。</i>新しい知識に対して好奇心を持てる人、技術を自立的に探究するのが好きで、学んだことをクライアントや社会のために役立てたい人には、この環境はマッチするでしょう。ただし、何でも人から教えてもらおうとする人は、向いていないと思います。「待ち」の姿勢になってしまうと、自主自立という豆蔵の精神に反してしまう。逆に、<i>「攻め」の姿勢で貪欲に吸収する意欲さえあれば、経験はそれほど必要ありません。</i>私自身もそうでした。入社当時、先輩コンサルタントから「君は豆蔵で一番モデリングの知識がないかもしれないけど、頑張ればできるようになるから」と励まされて、そこから猛勉強をしましたから。
            </p>' 
        :image="require('../assets/people_tadahiro/image03.jpg')" 
      />
    </People>
  </div>
</template>

<script>
// @ is an alias to /src
import People from '@/components/people/People.vue';
import PeopleArticle from '@/components/people/PeopleArticle.vue';
export default {
  name: 'people-tadahiro',
  components: {
    People,
    PeopleArticle
  },
}
</script>

<style lang="scss" scoped>
.people-tadahiro {
  width: 100%;
  overflow: hidden;
}
</style>